import { baseThemeValues } from 'constants/common';

const sellButtonBase = {
  bg: 'palette.transparent',
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: '600',
};

export const userScopeSectionTheme = {
  lessButton: {
    active: {
      ...sellButtonBase,
      text: 'palette.neutral.40',
    },
    base: {
      ...sellButtonBase,
      text: 'palette.neutral.40',
    },
    hover: {
      ...sellButtonBase,
      text: 'palette.neutral.60',
    },
  },
  title: 'palette.tertiary.90',
};
